import React from "react";
import "./QandAforContactus.css";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const QandAforcontactus = () => {
  const questionsAnswers = [
    {
      question: "מה זה BuyTaxi?",
      answer: "BuyTaxi הוא אתר שמאפשר למכור ולקנות מוניות יד שנייה וכן מוניות חדשות (0 קילומטר) בצורה קלה ונוחה."
    },
    {
      question: "האם הפרסום באתר הוא חינם?",
      answer: "כן! ניתן לפרסם מוניות למכירה בחינם לחלוטין."
    },
    {
      question: "איך ניתן לפרסם מונית?",
      answer: "ניתן לפרסם בקלות דרך וואטסאפ באמצעות השירות החדשני שלנו."
    },
    {
      question: "כמה מוניות ניתן לפרסם?",
      answer: "ניתן לפרסם עד 2 מוניות בו זמנית עם אותו מספר טלפון."
    },
    {
      question: "תוך כמה זמן מקבלים מענה בפנייה דרך 'צור קשר'?",
      answer: "זמן המענה הוא עד 3 ימי עסקים."
    },
    {
      question: "האם ניתן לרכוש גם מוניות חדשות דרך האתר?",
      answer: "כן! אנו מציעים גם מוניות חדשות 0 קילומטר."
    },
    {
      question: "האם האתר גובה עמלה על מכירה?",
      answer: "לא, האתר לא גובה עמלה על מכירה של מונית."
    },
    {
      question: "איך ניתן להסיר מודעה שפרסמתי?",
      answer: "ניתן לפנות אלינו דרך צור קשר, או דרך השירות לקוחות בוואטספ"
    }
  ];

  return (
    <div className="qanda-container">
      <Typography variant="h4" className="qanda-title">שאלות נפוצות</Typography>
      {questionsAnswers.map((qa, index) => (
        <Accordion key={index} className="qanda-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className="qanda-summary">
            <Typography className="qanda-question">{qa.question}</Typography>
          </AccordionSummary>
          <AccordionDetails className="qanda-details">
            <Typography className="qanda-answer">{qa.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default QandAforcontactus;